var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3945_4475)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.02804 0.0243439C3.96742 0.0359668 3.83459 0.0847031 3.73287 0.132639C3.49567 0.244424 3.24262 0.489239 3.1368 0.709386C2.99171 1.01118 3.00009 0.779345 3.00009 4.49097C3.00009 6.82336 3.00747 7.89951 3.02402 7.98096C3.06661 8.1906 3.21263 8.45537 3.37654 8.62022C3.54048 8.78505 3.80379 8.93188 4.01226 8.97471C4.17686 9.00853 9.82468 9.00838 9.9882 8.97455C10.2034 8.93004 10.4542 8.79081 10.6206 8.62358C10.7879 8.45526 10.9335 8.19248 10.9764 7.98096C10.9929 7.90022 11.0003 7.01966 11 5.18079C10.9996 2.28646 11.0025 2.36438 10.8826 2.0658C10.7688 1.78252 10.695 1.69118 10.0502 1.03567C9.37958 0.353942 9.24247 0.240601 8.95044 0.12655C8.61693 -0.00368005 8.65226 -0.00199106 6.2966 0.000720216C5.03521 0.00216475 4.09246 0.0119876 4.02804 0.0243439ZM8.54532 0.743632C8.80462 0.805102 8.87435 0.859106 9.50445 1.4863C10.0674 2.04667 10.1016 2.08549 10.1896 2.26335L10.2821 2.45056L10.2885 5.11908C10.2934 7.17671 10.2887 7.81048 10.2677 7.8876C10.2321 8.01899 10.0338 8.22226 9.90384 8.26071C9.77233 8.29962 4.22813 8.29962 4.09661 8.26071C3.97374 8.22437 3.77019 8.0197 3.73406 7.89613C3.71364 7.82631 3.70734 7.01888 3.70752 4.48482L3.70774 1.16497L3.75976 1.05261C3.82001 0.922509 3.96107 0.791835 4.09151 0.745321C4.23045 0.695785 8.33685 0.694229 8.54532 0.743632ZM5.11599 3.34106C5.00677 3.38057 4.97284 3.41095 4.91876 3.51753C4.83644 3.67977 4.88999 3.85764 5.05519 3.97069L5.12825 4.0207H7.00023H8.87221L8.94527 3.97069C9.05104 3.89831 9.10309 3.81711 9.11566 3.7049C9.13009 3.57614 9.06452 3.44371 8.95126 3.3729L8.8677 3.32066L7.03338 3.31581C5.5377 3.31188 5.18372 3.31652 5.11599 3.34106ZM5.11599 4.76337C5.00677 4.80288 4.97284 4.83326 4.91876 4.93984C4.83644 5.10207 4.88999 5.27995 5.05519 5.393L5.12825 5.44301H7.00023H8.87221L8.94527 5.393C9.05104 5.32062 9.10309 5.23942 9.11566 5.12721C9.13009 4.99845 9.06452 4.86602 8.95126 4.79521L8.8677 4.74296L7.03338 4.73812C5.5377 4.73419 5.18372 4.73883 5.11599 4.76337ZM5.11599 6.18567C5.00677 6.22519 4.97284 6.25557 4.91876 6.36215C4.83644 6.52438 4.88999 6.70226 5.05519 6.81531L5.12825 6.86531H7.00023H8.87221L8.94527 6.81531C9.05104 6.74293 9.10309 6.66173 9.11566 6.54952C9.13009 6.42075 9.06452 6.28832 8.95126 6.21752L8.8677 6.16527L7.03338 6.16043C5.5377 6.15649 5.18372 6.16114 5.11599 6.18567Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6L1 11.5H3.5",
    stroke: "currentColor",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6V11.5H10.5",
    stroke: "currentColor",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51213 12.5121C5.32314 12.3231 5.45699 12 5.72426 12H8.27574C8.54301 12 8.67686 12.3231 8.48787 12.5121L7.21213 13.7879C7.09497 13.905 6.90503 13.905 6.78787 13.7879L5.51213 12.5121Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10.5V12",
    stroke: "#7E8CA8",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3945_4475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/download-file.b267e61e2a4fd63950c9786b0b1c2216.svg";
export { ForwardRef as ReactComponent };